module.exports = __webpack_public_path__ + "assets/img/logo.3eade411.png";